/* eslint-disable no-underscore-dangle */

export const RECAPTCHA_ERROR_MESSAGE =
  'There was an error submitting your donation. Please try again. If the issue persists, contact membership@texastribune.org.';

export const STRIPE_KEY = window.__STRIPE_KEY__;

export const RECAPTCHA_KEY = window.__RECAPTCHA_KEY__;
